// Увеличение вложения, ещё не отправленного: до отправки убедиться, что
// прикреплён нужный кадр, можно было только по миниатюре 16×16, хотя в карточке
// сообщения то же самое открывается лайтбоксом. Состояние держится по `localId`,
// а не по индексу: соседа можно убрать или переставить, пока лайтбокс открыт.
//
// Лента — весь канал целиком, включая звук: стрелками листается всё, что канал
// набрал, как в сообщении. Кликом открывается только кадр — у звука увеличивать
// нечего, он играет прямо в плитке (`AttachmentThumbBody`).

import { useCallback, useMemo, useState } from "react";

import type { PendingUpload } from "~/shared/store/types";
import type { MediaLightboxItem } from "~/shared/ui/media-lightbox";

/** Вложения без ссылки на превью (ещё не загруженные) в ленту не попадают. */
function toLightboxItem(item: PendingUpload): MediaLightboxItem | null {
    if (item.previewUrl === undefined) return null;
    if (item.kind !== "image" && item.kind !== "video" && item.kind !== "audio") return null;
    return { url: item.previewUrl, type: item.kind, caption: item.fileName };
}

export function usePendingLightbox(items: readonly PendingUpload[]) {
    const [openId, setOpenId] = useState<string | null>(null);

    const feed = useMemo(() => {
        const lightboxItems: MediaLightboxItem[] = [];
        const idByPosition: string[] = [];
        for (const item of items) {
            const slide = toLightboxItem(item);
            if (!slide) continue;
            lightboxItems.push(slide);
            idByPosition.push(item.localId);
        }
        return { lightboxItems, idByPosition };
    }, [items]);

    const openAt = useCallback((localId: string) => setOpenId(localId), []);
    const close = useCallback(() => setOpenId(null), []);

    const openIndex = openId === null ? -1 : feed.idByPosition.indexOf(openId);

    return {
        items: feed.lightboxItems,
        // Вложение убрали, пока лайтбокс открыт, — закрываемся, а не показываем
        // чужой слайд, съехавший на освободившееся место.
        isOpen: openIndex >= 0,
        initialIndex: openIndex >= 0 ? openIndex : 0,
        openAt,
        close,
    };
}
